import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { VoiceActorState } from './types';
import {
  createVoiceActor,
  editVoiceActor,
  getVoiceActorById,
  getVoiceActorByIdMultilingual,
  getVoiceActorsDatatable,
  getVoiceActorsLookups,
  setContentEntityVoiceActor,
} from './thunks';

export const name = 'voiceActors';

export const getVoiceActorsDatatableAsync = createAsyncThunk(
  name + '/getVoiceActorsDatatable',
  getVoiceActorsDatatable
);

export const getVoiceActorsLookupsAsync = createAsyncThunk(
  name + '/getVoiceActorsLookups',
  getVoiceActorsLookups
);

export const getVoiceActorByIdAsync = createAsyncThunk(
  name + '/getVoiceActorById',
  getVoiceActorById
);

export const createVoiceActorAsync = createAsyncThunk(
  name + '/createVoiceActor',
  createVoiceActor
);

export const editVoiceActorAsync = createAsyncThunk(
  name + '/editVoiceActor',
  editVoiceActor
);

export const getVoiceActorByIdMultilingualAsync = createAsyncThunk(
  name + '/getVoiceActorByIdMultilingual',
  getVoiceActorByIdMultilingual
);

export const setContentEntityVoiceActorAsync = createAsyncThunk(
  name + '/setContentEntityVoiceActor',
  setContentEntityVoiceActor
);

const initialState: VoiceActorState = {
  datatable: {
    data: null,
    status: 'idle',
  },
  lookups: {
    data: null,
    status: 'idle',
  },
  getVoiceActorById: {
    data: null,
    status: 'idle',
  },
  createVoiceActor: {
    data: null,
    status: 'idle',
  },
  editVoiceActor: {
    status: 'idle',
  },
  byIdMultilingual: {
    data: null,
    status: 'idle',
  },
  setContentEntityVoiceActor: {
    status: 'idle',
  },
};

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearVoiceActorById: (state) => {
      state.getVoiceActorById = initialState.getVoiceActorById;
    },
    clearByIdMultilingual: (state) => {
      state.byIdMultilingual = {
        data: null,
        status: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getVoiceActorsDatatableAsync.pending, (state) => {
        state.datatable.status = 'loading';
      })
      .addCase(getVoiceActorsDatatableAsync.fulfilled, (state, action) => {
        state.datatable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getVoiceActorsDatatableAsync.rejected, (state) => {
        state.datatable.status = 'failed';
      })

      .addCase(getVoiceActorsLookupsAsync.pending, (state) => {
        state.lookups.status = 'loading';
      })
      .addCase(getVoiceActorsLookupsAsync.fulfilled, (state, action) => {
        state.lookups = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getVoiceActorsLookupsAsync.rejected, (state) => {
        state.lookups.status = 'failed';
      })
      .addCase(getVoiceActorByIdAsync.pending, (state) => {
        state.getVoiceActorById.status = 'loading';
      })
      .addCase(getVoiceActorByIdAsync.fulfilled, (state, action) => {
        state.getVoiceActorById = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getVoiceActorByIdAsync.rejected, (state) => {
        state.getVoiceActorById.status = 'failed';
      })
      .addCase(createVoiceActorAsync.pending, (state) => {
        state.createVoiceActor.status = 'loading';
      })
      .addCase(createVoiceActorAsync.fulfilled, (state, action) => {
        state.createVoiceActor = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createVoiceActorAsync.rejected, (state) => {
        state.createVoiceActor.status = 'failed';
      })
      .addCase(editVoiceActorAsync.pending, (state) => {
        state.editVoiceActor.status = 'loading';
      })
      .addCase(editVoiceActorAsync.fulfilled, (state) => {
        state.editVoiceActor.status = 'idle';
      })
      .addCase(editVoiceActorAsync.rejected, (state) => {
        state.editVoiceActor.status = 'failed';
      })
      .addCase(getVoiceActorByIdMultilingualAsync.pending, (state) => {
        state.byIdMultilingual.status = 'loading';
      })
      .addCase(
        getVoiceActorByIdMultilingualAsync.fulfilled,
        (state, action) => {
          state.byIdMultilingual = {
            data: action.payload,
            status: 'idle',
          };
        }
      )
      .addCase(getVoiceActorByIdMultilingualAsync.rejected, (state) => {
        state.byIdMultilingual.status = 'failed';
      })
      .addCase(setContentEntityVoiceActorAsync.pending, (state) => {
        state.setContentEntityVoiceActor.status = 'loading';
      })
      .addCase(setContentEntityVoiceActorAsync.fulfilled, (state) => {
        state.setContentEntityVoiceActor.status = 'idle';
      })
      .addCase(setContentEntityVoiceActorAsync.rejected, (state) => {
        state.setContentEntityVoiceActor.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
